class GzProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.products = [];
    this.recommendedProducts = [];

    this.price = parseInt(this.getAttribute('gz-price')) || 0;
    this.priceThreshold = parseInt(this.getAttribute('gz-price-threshold')) || 100;
    this.brand = this.getAttribute('gz-brand').toLowerCase() || null;
    this.model = this.getAttribute('gz-model').toLowerCase() || null;
    this.carrier = this.getAttribute('gz-carrier').toLowerCase() || null;
    this.storage = this.getAttribute('gz-storage').toLowerCase() || null;
    this.productsToShow = parseInt(this.getAttribute('gz-products-to-show')) || 10;
    this.productsPerRow = parseInt(this.getAttribute('gz-products-per-row')) || 4;

    this.productList = this.querySelector(".gz-product-recommendations__list") || null;
    this.sliderPagination =  this.querySelector(".slider-buttons") || null;
    this.slider = this.querySelector("slider-component") || null;

    this.iphoneModels = [
      "iPhone 7", "iPhone 7 Plus", "iPhone 8", "iPhone 8 Plus", "iPhone X", "iPhone XR", "iPhone XS", "iPhone XS Max", 
      "iPhone 11", "iPhone 11 Pro", "iPhone 11 Pro Max", "iPhone 12", "iPhone 12 Mini", "iPhone 12 Pro", "iPhone 12 Pro Max", 
      "iPhone 13", "iPhone 13 Mini", "iPhone 13 Pro", "iPhone 13 Pro Max", "iPhone 14", "iPhone 14 Plus", "iPhone 14 Pro", 
      "iPhone 14 Pro Max", "iPhone 15", "iPhone 15 Plus", "iPhone 15 Pro", "iPhone 15 Pro Max"
    ];

    this.ipadModels = [
      "iPad Air 2", "iPad 5", "iPad 6", "iPad 7", "iPad 8", "iPad 9", "iPad 10", "iPad Air 3", "iPad Air 4", "iPad Air 5", 
      "iPad Mini 4", "iPad Mini 5", "iPad Mini 6", "iPad Pro 10.5 2nd Gen", "iPad Pro 11 1st Gen", "iPad Pro 11 2nd Gen", 
      "iPad Pro 11 3rd Gen"
    ];

    this.samsungModels = [
      "Galaxy Note 9", "Galaxy Note 10", "Galaxy Note 10+", "Galaxy Note 10+ 5G", "Galaxy Note 20", "Galaxy Note 20 5G", 
      "Galaxy Note 20 Ultra", "Galaxy Note 20 Ultra 5G", "Galaxy S10e", "Galaxy S10", "Galaxy S10+", "Galaxy S10 5G", "Galaxy S20", 
      "Galaxy S20+", "Galaxy S20 Ultra", "Galaxy S20 FE 5G", "Galaxy S21", "Galaxy S21+", "Galaxy S21 Ultra 5G", "Galaxy S21 FE 5G", 
      "Galaxy S22", "Galaxy S22+", "Galaxy S22 Ultra 5G", "Galaxy S23", "Galaxy S23+", "Galaxy S23 Ultra", "Galaxy S23 FE", 
      "Galaxy S24", "Galaxy S24+", "Galaxy S24 Ultra", "Galaxy Z Flip3 5G", "Galaxy Z Flip4", "Galaxy Z Fold5"
    ];

    this.googlePhoneModels = [
      "Google Pixel 4", "Google Pixel 4 XL", "Google Pixel 4a", "Google Pixel 5", "Google Pixel 6 Pro", "Google Pixel 6a", 
      "Google Pixel 7", "Google Pixel 7 Pro", "Google Pixel 9", "Google Pixel 9 Pro", "Google Pixel 9 Pro Fold", "Google Pixel 9 Pro XL", 
      "Pixel 4", "Pixel 4 XL", "Pixel 4a", "Pixel 5", "Pixel 6", "Pixel 6 Pro", "Pixel 6a", "Pixel 7a", "Pixel 8", "Pixel 8 Pro", 
      "Pixel 8a", "Pixel Fold"
    ];
  }

  connectedCallback() {
    this.init();
  }

  async init() {
    this.setLoadingState(true);
  
    this.renderProductSkeletons();
    await this.fetchProducts();
  
    this.setLoadingState(false);
  }


  //
  // Fetch All Products
  //
  async fetchProducts() {
    let collectionHandle = null;

    if (this.model.includes("samsung") || this.model.includes("galaxy")) {
      collectionHandle = "samsung-galaxy";
    } else if (this.model.includes("google") || this.model.includes("pixel")) {
      collectionHandle = "google-phones";
    } else if (this.model.includes("iphone")) {
      collectionHandle = "iphones";
    } else if (this.model.includes("ipad")) {
      collectionHandle = "ipads";
    }

    if (!collectionHandle) {
      this.kill();
      return;
    }

    const baseUrl = `${window.shopUrl}/collections/${collectionHandle}/products.json?page=`;
    let page = 1;
    const startTime = Date.now();
  
    while (true) {
      try {
        const response = await fetch(baseUrl + page);
        const data = await response.json();
  
        if (data.products && data.products.length > 0) {
          const filteredProducts = await Promise.all(
            data.products.map(async (product) => {
              const {
                available,
                price,
                compareAtPrice,
                msrp,
                media,
                brand,
                model,
                storage,
                carrier,
                variants,
                optionsWithValues
              } = await this.fetchProductAdditionalData(product.handle);
  
              return {
                id: product.id,
                title: product.title,
                handle: product.handle,
                available,
                price,
                compareAtPrice,
                msrp,
                media,
                brand,
                model,
                storage,
                carrier,
                variants,
                optionsWithValues,
              };
            })
          );
  
          this.products = this.products.concat(filteredProducts);
          page++;
        } else {
          break;
        }
      } catch (error) {
        console.error("Error fetching products:", error);
        break;
      }
    }
  
    const endTime = Date.now();
    const totalTimeInSeconds = (endTime - startTime) / 1000;
  
    console.log(`Total time to fetch all products: ${totalTimeInSeconds.toFixed(2)} seconds`);
    this.getRecommendedProduct();
  }


  //
  // Fetch Additional Product Data from /${handle}?view=json
  //
  async fetchProductAdditionalData(handle) {
    if(!handle) {
      return;
    }

    try {
      const response = await fetch(`${window.shopUrl}/products/${handle}?view=json`);
      const data = await response.json();
      
      const res = {
        available: data.available || false,
        price: data.price || 0,
        compareAtPrice: data.compare_at_price || 0,
        msrp: data.msrp || 0,
        media: data.media || [],
        brand: data.brand?.toLowerCase() || '',
        model: data.model?.toLowerCase() || '',
        storage: data.storage?.toLowerCase() || '',
        carrier: data.carrier?.toLowerCase() || '',
        variants: data.variants || [],
        optionsWithValues: data.options_with_values || [],
      }

      return res;
    } catch (error) {
      console.error('Error fetching product data:', error);
      return res;
    }
  }
  

  //
  // Sort & Filter Products, Get Recommended Products
  //
  getRecommendedProduct() {
    if (!this.products.length) {
      this.kill();
      return;
    }
  
    // Recommended Products Should Meet All Criteria:
    // Criteria are checked against the current Product on PDP
    this.recommendedProducts = this.products.filter(product => {
      
      // 1. Product should be available
      if (!product.available) {
        return false;
      }

      // 2. Product should be the same 'brand'
      if (product.brand !== this.brand) {
        return false;
      }

      // 3. Product should be the same 'carrier'
      if (product.carrier !== this.carrier) {
        return false;
      }
  
      // 4. Product should be a newer model
      if (!this.isNewerModel(product.model)) {
        return false;
      }

      // 5. Product price should be greater but no more than priceThreshold (%) higher
      if (product.price < this.price || product.price > this.price * (this.priceThreshold / 100)) {
        return false;
      }

      // 6. Product storage should be greater
      if (!this.hasGreaterStorage(product.storage)) {
        return false;
      }
  
      // If all conditions are met, return true (the product is recommended)
      return true;
    });
  
    // Sort recommended products by price in ascending order
    this.recommendedProducts.sort((a, b) => a.price - b.price);
  
    // Limit the recommended products to show (based on the number of products to show)
    this.recommendedProducts = this.recommendedProducts.slice(0, this.productsToShow);
  
    // Render the recommended products
    this.renderProducts();
  }

  //
  // Render Product Cards
  //
  renderProducts() {
    if (this.recommendedProducts.length === 0 || !this.productList) {
      this.kill();
      return;
    }
  
    const productGridHtml = this.recommendedProducts.map(product => this.productCardTemplate(product)).join('');
    this.productList.innerHTML = productGridHtml;

    if (this.slider) {
      this.handleSliderPagination();
      this.initSlider();
    }
  }


  //
  // Product Card Template
  //
  productCardTemplate(product) {
    const { 
      title,
      handle,
      available,
      price,
      compareAtPrice,
      msrp,
      media,
      variants,
      optionsWithValues
    } = product;

    let onSale = false;
    let outOfStock = false;
    let oldPrice = false;
    
    let minPrice = 0;
    let maxPrice = 0;
    let minComparePrice = 0;
    let maxComparePrice = 0;
  
    variants.forEach(variant => {
      if (variant.available) {
        const variantPrice = parseInt(variant.price || 0);
        const variantCompareAtPrice = parseInt(variant.compare_at_price || 0);

        if (minPrice === 0 || variantPrice < minPrice) minPrice = variantPrice;
        if (maxPrice === 0 || variantPrice > maxPrice) maxPrice = variantPrice;
        if (minComparePrice === 0 || variantCompareAtPrice < minComparePrice) minComparePrice = variantCompareAtPrice;
        if (maxComparePrice === 0 || variantCompareAtPrice > maxComparePrice) maxComparePrice = variantCompareAtPrice;
      }
    });
  
    // Check if the product is on sale
    if (compareAtPrice > price && available) {
      onSale = true;
    }
  
    // Check if the product is out of stock
    if (!available) {
      outOfStock = true;
    }
  
    // Check for old price
    if (minComparePrice > 0 && onSale) {
      oldPrice = minComparePrice;
    }
    if (!onSale && msrp) {
      oldPrice = msrp;
    }

    // Generate Color Swatches
    const generateSwatches = (optionsWithValues) => {
      const swatchesContainer = [];
    
      optionsWithValues.forEach(option => {
        if (option.Color || option.color) {
          const colorName = option.Color.toLowerCase() || option.color.toLowerCase();
          const matchingSwatch = GzTheme.SWATCHES.find(swatch => swatch.name.toLowerCase() === colorName);

          if (matchingSwatch) {
            const swatch = `<span class="gz-card-product__swatch" title="${colorName}" style="background-color: ${matchingSwatch.color};"></span>`;
            swatchesContainer.push(swatch);
          }
        }
      });
    
      return swatchesContainer.join('');
    };
  
    return `
      <li id="Slide-${handle}" class="collection-list__item grid__item slider__slide">
        <div class="gz-card-product ${onSale ? 'gz-card-product--onsale' : ''} ${outOfStock ? 'gz-card-product--oos' : ''}">
          ${media ? `
            <a class="gz-card-product__media" title="${title}" href="/products/${handle}">
              <div class="gz-card-product__images">
                ${media[0] ? `
                  <img src="${media[0].preview_image_md}" alt="${media[0].alt} Image 1" class="motion-reduce" loading="lazy" />
                ` : ''}
                ${media[1] ? `
                  <img src="${media[1].preview_image_md}" alt="${media[1].alt} Image 2" class="motion-reduce" loading="lazy" />
                ` : ''}
              </div>
    
              ${outOfStock ? `<span class="gz-card-product__badge gz-card-product__badge--oos">Sold Out</span>` : ''}
              ${onSale ? `<span class="gz-card-product__badge gz-card-product__badge--sale">On Sale</span>` : ''}
            </a>
          ` : ''}
          
          <a class="gz-card-product__content" title="${title}" href="/products/${handle}">
            <h3 class="gz-card-product__title">
              ${title}
            </h3>

            <div class="gz-card-product__pricing">
              <span class="gz-card-product__regular-price">
                <span>From</span>
                <span>${this.moneyWithTrailingZeros(price)}</span>
              </span>

              <div class="gz-card-product__swatches">
                ${generateSwatches(optionsWithValues)}
              </div>

              ${oldPrice ? `<span class="gz-card-product__old-price"> <span>${this.moneyWithoutTrailingZeros(oldPrice)}</span> new </span>` : ''}

              <span class="gz-card-product__final-price">
                ${this.moneyWithTrailingZeros(price)}
              </span>

              ${minPrice > 0 && maxPrice > 0 ? `
                <span class="gz-card-product__range-price">
                  ${oldPrice ? `<span class="gz-card-product__old-price">${this.moneyWithoutTrailingZeros(oldPrice)}</span>` : ''}
                  <span class="min">${this.moneyWithoutTrailingZeros(minPrice)}</span> 
                  <span class="tilde">&#126;</span>
                  <span class="max">${this.moneyWithoutTrailingZeros(maxPrice)}</span>
                </span>
              ` : 
                `<span class="gz-card-product__range-price">
                  ${oldPrice ? `<span class="gz-card-product__old-price">${this.moneyWithoutTrailingZeros(oldPrice)}</span>` : ''}
                  ${this.moneyWithTrailingZeros(price)}
                </span>`
              }
            </div>
          </a>
        </div>
      </li>
    `;
  }


  // 
  // Render Product Skeletons
  //
  renderProductSkeletons() {
    if (!this.productList) {
      this.kill();
      return;
    }

    this.productList.innerHTML = `
      ${
        `<li id="Slide-${new Date()}" class="collection-list__item grid__item slider__slide">
          <div class="gz-product-card-skeleton">
            <span class="gz-skeleton-loader image"></span>
            <span class="gz-skeleton-loader title"></span>
            <span class="gz-skeleton-loader price"></span>
          </div>
        </li>`.repeat(this.productsPerRow)
      }
    `;
  }


  //
  // Handle slider pagination - show only if this.recommendedProducts > this.productsPerRow
  //
  handleSliderPagination() {
    this.sliderPagination.style.display = this.recommendedProducts.length > this.productsPerRow ? 'flex' : 'none';
  }


  //
  // Refresh Slider
  //
  initSlider() {
    if(!this.slider) return;

    if (this.slider instanceof SliderComponent) {
      this.slider.refreshSlider();
    }
  }


  //
  // Set Loading State
  //
  setLoadingState(isLoading) {
    this.classList.toggle('loading', isLoading);
  }


  //
  // Check if Model is Newer
  //
  isNewerModel(productModel) {
    let currentModelList;
  
    if (this.model.includes("iphone")) {
      currentModelList = this.iphoneModels.map(model => model.toLowerCase());
    } else if (this.model.includes("ipad")) {
      currentModelList = this.ipadModels.map(model => model.toLowerCase());
    } else if (this.model.includes("samsung") || this.model.includes("galaxy")) {
      currentModelList = this.samsungModels.map(model => model.toLowerCase());
    } else if (this.model.includes("google") || this.model.includes("pixel")) {
      currentModelList = this.googlePhoneModels.map(model => model.toLowerCase());
    } else {
      return false;
    }
  
    const currentModelIndex = currentModelList.indexOf(this.model.toLowerCase());
    const productModelIndex = currentModelList.indexOf(productModel.toLowerCase());
    return productModelIndex > currentModelIndex;
  }


  //
  // Check if Storage is Greater
  //
  hasGreaterStorage(productStorage) {
    return this.convertStorageToGB(productStorage) > this.convertStorageToGB(this.storage);
  }


  //
  // Convert storage to GB
  //
  convertStorageToGB(storage) {
    if (!storage) return 0;
    const value = parseFloat(storage);
    return storage.toLowerCase().endsWith('t') ? value * 1000 : value;
  }

  
  //
  // Cents to Decimal Ex: 1200 -> 12.00
  //
  moneyWithTrailingZeros(cents) {
    if (isNaN(cents)) return '$0.00';
    return `$${(cents / 100).toFixed(2)}`;
  }


  //
  // Cents to without Decimal Ex: 1200 -> 12
  //
  moneyWithoutTrailingZeros(cents) {
    if (isNaN(cents)) return '$0';
    return `$${Math.ceil(cents / 100)}`;
  }


  //
  // Unmount/Kill Component
  //
  kill() {
    this.parentNode.remove();
  }
}

customElements.define('gz-product-recommendations', GzProductRecommendations);